<template>
    <div class="user-balance">
        <div class="balance-container">
            <div class="balance-top">
                <div class="balance-icon"></div>
                <div class="balance-info">
                    <div class="info-title">我的消费券</div>
                    <div class="info-balance-wrap">
                        <div class="info-price">{{userInfo.c_coupon || 0 }}</div>
                        
                    </div>
                </div>
            </div>
            <div class="filter-search-container">
                <div class="filter-box">
                    <div class="filter-label">消费券明细</div>
                    <div v-for="(item,index) in filter_list" :key="index" :class="['filter-item',{active:filter_form.type === item.value}]" @click="onTypeChange(item.value)">{{item.name}}</div>
                </div>
                <div class="search-box">
                    
                    <Dropdown class="search-time-box" @on-click="onTimeFilter">
                        <div class="time-dropdown">
                            <div class="time-value">{{ current_time_filter }}</div>
                            <Icon type="ios-arrow-down" class="arrow-down-icon" />
                        </div>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="(item,index) in time_filter" :key="index" :name="item.value">{{item.name}}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>日期</th>
                        <th>变动说明</th>
                        <th>类别</th>
                        <th>消费券变化</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="list.length>0">
                        <tr v-for="(item,index) in list" :key="index">
                            <td>{{item.create_time}}</td>
                            <td>
                                <div>{{ item.message }}</div>
                            </td>
                            <td>
                                <div :class="['value-type',{'income':Number(item.value) > 0,'pay-out':Number(item.value) < 0}]"> {{ item.value >0?'获得':'消耗' }}</div>
                            </td>
                            <td>
                                <div :class="['price-box',{'income':Number(item.value) > 0,'pay-out':Number(item.value) < 0}]">{{ item.value >0?'+':'' }}{{ item.value }}</div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="4" align="center">暂无数据</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div class="pagination-container">
                <Page :total="total_count" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
            </div>
        </div>
       
    </div>
</template>
<script>
import { getCouponLog } from '@/api/index';

import { mapState } from 'vuex';
export default{
    data(){
        return{
            filter_list:[
                {name:'全部',value:'-1'},
                {name:'获得',value:'1'},
                {name:'消耗',value:'2'},
            ],
            time_filter:[
                {name:'全部时间',value:''},
                {name:'1个月',value:'1'},
                {name:'3个月',value:'3'},
                {name:'6个月',value:'6'},
                {name:'1年',value:'12'},
                {name:'1年以上',value:'12+'}
            ],
            filter_form:{
                type:'-1',
                keyword:"",
                page:1,
                limit:10,
                time_range:''
            },
            show_charge_pop:false,
            show_charge_success:false,
            temp_charge_amount:'',
            list:[],
            total_count:0
        }
    },
    filters:{
        
    },
    components:{
      
    },
    computed:{
        current_time_filter(){
            const {filter_form,time_filter} = this;
            return time_filter.filter((item)=>item.value === filter_form.time_range)[0].name;
        },
        ...mapState({
            userInfo:(state)=>state.userInfo
        })
    },
    mounted(){
        this.$store.dispatch('getUser');
        this.onGetBalanceLog();
    },
    methods:{
        onSearchKeyword(){
            console.log('on-search-keyword');
            this.filter_form.page = 1;
            this.onGetBalanceLog();
        },
        onTypeChange(type){
            this.filter_form.page = 1;
            this.filter_form.type = type;
            this.onGetBalanceLog();
        },
        async onGetBalanceLog(){
            try{
                const {data} = await getCouponLog(this.filter_form);
                console.log('data',data);
                this.total_count = data.count;
                this.list = data.list;
            }catch(e){
                console.log('err-balance-log',e);
            }
        },
        onPageChange(e){
            console.log('page_change',e);
            this.filter_form.page = e;
            this.onGetBalanceLog();
        },
        onChargeSuccess({amount}){
            console.log('on-charge-success',amount);
            this.temp_charge_amount = amount
            this.show_charge_pop = false;
            this.show_charge_success = true;
        },
        onTimeFilter(time){
            console.log('time',time);
            this.filter_form.page = 1;
            this.filter_form.time_range = time;
            this.onGetBalanceLog();
        }
    }
}
</script>
<style lang="scss" scoped>
.user-balance{
    width:100%;
    min-height:100vh;
    display:flex;
    flex-direction:column;
    .balance-container{
        padding:40px;
        width:100%;
        flex:1;
        background:#ffffff;
        display:flex;
        flex-direction:column;
        .balance-top{
            width:100%;
            height:150px;
            border-radius:20px;
            background:#fff7f7;
            display:flex;
            align-items:center;
            position:relative;
            column-gap:129px;
            .balance-icon{
                position:absolute;
                left:0;
                bottom:0;
                width:128px;
                height:114px;
                background:url('../../assets/images/icon-point-detail.png') no-repeat;
                background-size:cover;
            }
            .balance-info{
                margin-left:188px;
                display:flex;
                flex-direction:column;
                row-gap:24px;
                .info-title{
                    color:#1f1f1f;
                    font-size:14px;
                }
                .info-balance-wrap{
                    display:flex;
                    align-items:center;
                    column-gap:129px;
                    .info-price{
                        color:#1f1f1f;
                        font-size:30px;
                        font-weight:bold;
                    }
                    .charge-btn{
                        width:88px;
                        height:34px;
                        background:#ff5967;
                        color:#ffffff;
                        text-align:center;
                        line-height:34px;
                        border-radius:5px;
                        cursor:pointer;
                    }
                }
                
            }
        }
        .filter-search-container{
            margin-top:30px;
            margin-bottom:25px;
            display:flex;
            align-items:center;
            justify-content:space-between;
            .filter-box{
                display:flex;
                align-items:center;
                column-gap:17px;
                .filter-label{
                    color:#1a1a1a;
                    font-size:18px;
                    font-weight:bold;
                    margin-right:10px;
                }
                .filter-item{
                    padding:10px 25px;
                    color:#666666;
                    font-size:14px;
                    border-radius:5px;
                    background:#f8f9fa;
                    cursor:pointer;
                    &.active{
                        color:#ff5967;
                        background:rgba(255,89,103,0.1);
                    }
                }
            }
            .search-box{
                display:flex;
                align-items:center;
                column-gap:15px;
                .search-time-box{
                    background:#f9fafb;
                    border:1px solid #ebebeb;
                    border-radius:8px;
                    width:114px;
                    height:38px;
                    cursor:pointer;
                    .time-dropdown{
                        width:100%;
                        height:38px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:8px;
                        .time-value{
                            color:#333333;
                            font-size:14px;
                        }
                        .arrow-down-icon{
                            width:16px;
                            height:16px;
                        }
                    }
                }
                .search-keyword-box{
                    width:190px;
                    height:38px;
                    border-radius:8px;
                    border:1px solid #e0e0e0;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    column-gap:10px;
                    overflow:hidden;
                    .search-icon{
                        font-size:22px;
                        padding-left:8px;
                        flex-shrink:0;
                        // margin-right:9px;
                    }
                    .search-input{
                        border:none;
                        outline:none;
                        height:100%;
                        flex:1;
                        min-width:0;
                        margin-right:8px;
                    }
                }
            }
        }
        table{
            width:100%;
            table-layout:fixed;
            border-collapse: collapse;
            border:1px solid #e0e0e0;
            thead{
                background:#edeff2;
            }
            thead > tr > th{
                text-align: center;
                color:#808080;
                font-size:14px;
            }
            tr{
                height:48px;
            }
            tbody > tr{
                border-bottom:1px solid #ebebeb;
                &:hover{
                    background:#f5f5f5;
                }
                > td{
                    text-align: center;
                    color:#333333;
                    font-size:14px;
                    .value-type{
                        font-size:14px;
                        font-weight:bold;
                        &.income{
                            color:#ff5967;
                        }
                        &.pay-out{
                            color:#3bb46d;
                        }
                    }
                    .price-box{
                        font-weight:bold;
                        font-size:14px;
                        &.income{
                            color:#ff5967;
                        }
                        &.pay-out{
                            color:#3bb46d;
                        }
                    }
                }
            }
        }
        .pagination-container{
            margin-top:20px;
            display:flex;
            justify-content:flex-end;
            align-items:center;
        }
    }
}
</style>